import React, { useState } from "react";
import { Icon } from '@iconify/react';
import './styles/style.scss';

const PersonalInformation = ({ formState, setFormState, pageState, setPageState }) => {
  const onInputChange = (e) => {
    setPageState({
      ...pageState,
      [e.target.name]: e.target.value,
    })
  }

  return (
    <>
      <h1 className="title-personal"> <Icon icon="fa:address-card-o" /> Personal Information</h1>
      <p><i>We only collect what's needed, and we encrypt your personal data for security.</i></p>
      <form id="form" className="form" autoComplete="off" noValidate>
        <fieldset>
          <input onChange={onInputChange} value={pageState.address_address} type="text" name="address_address" id="address_address" required className="input" />
          <label htmlFor="address_address" className="input-label">Mailing Address</label>
        </fieldset>
        <span className="address-info">
          <fieldset className="fieldset-address">
            <input onChange={onInputChange} value={pageState.address_city} name="address_city" type="text" id="address_city" required className="input" />
            <label htmlFor="address_city" className="input-label">City</label>
          </fieldset>
          <fieldset className="fieldset-state">
            <input onChange={onInputChange} value={pageState.state} type="text" name="address_state" id="address_state" required className="input" />
            <label htmlFor="address_state" className="input-label">State</label>
          </fieldset>
          <fieldset className="fieldset-zip">
            <input onChange={onInputChange} value={pageState.zip} type="text" name="address_zip" id="address_zip" required className="input" />
            <label htmlFor="address_zip" className="input-label">Zip Code</label>
          </fieldset>
        </span>
        <fieldset>
          <input onChange={onInputChange} type="text" name="ss" id="ss" required className="input" value={pageState.ss} />
          <label htmlFor="ss" className="input-label">Social Security Number (last 4 only)</label>
        </fieldset>
        <fieldset>
          <input onChange={onInputChange} type="text" name="dob" id="dob" required className="input" value={pageState.dob} />
          <label htmlFor="dob" className="input-label">Date of Birth (mm/dd/yyyy)</label>
        </fieldset>
        <fieldset>
          <input onChange={onInputChange} value={pageState.referral} type="text" name="referral" id="referral" required className="input" />
          <label htmlFor="referral" className="input-label">How did you hear about us?</label>
        </fieldset>
        <fieldset>
          <label for="objective">Why are you looking to repair your credit?</label>
          <div class="select">
            <select onChange={onInputChange} value={pageState.objective} name="objective" id="objective">
              <option value="no answer">-- Select --</option>
              <option value="solar">Solar Business</option>
              <option value="buy home">Finance Home</option>
              <option value="clean up">Clean up Credit</option>
              <option value="police">Police/Government Job</option>
              <option value="other">Other</option>
            </select>
          </div>
        </fieldset>
      </form>
    </>
  )
}

export default PersonalInformation;